export default "/images/vendor/flag-icon-css/flags/1x1/sn.svg?a03bc309423c9052891ad0e5e65dbcee";